import { Injectable } from '@angular/core';
import { DataService } from '../data/data.service';

@Injectable({
    providedIn: 'root',
})
export class LocalStorageService {
    constructor(private dataService: DataService) {}
    getDataFromLocalStorage(key: string): string[] | null {
        try {
            const data = localStorage.getItem(key);
            return data ? JSON.parse(data) : [];
        } catch (e) {
            console.error(`Unable to read from local storage: ${e}`);
            return null;
        }
    }

    setDataInLocalStorage(key: string, value: any): void {
        try {
            localStorage.setItem(key, JSON.stringify(value));
            this.dataService.$localStorage.next({ key: key, value: value });
        } catch (e) {
            console.error(`Unable to store data in local storage: ${e}`);
        }
    }
}
